module.exports = __webpack_public_path__ + "img/more.4a4218ae.svg";